import logger from "@next/core-logger"
import {IncomingHttpHeaders} from "http"
import configRelativePathURL from "../../utils/configUrlPath"
import {axiosInstance as axios} from "../../utils/axios"
import AppApiConfig from "../../config/api/meganavdata"
import {SEO_IGNORE_LINK, SEO_IGNORE_LINK_REGEX, TPLITE_CLIENT_EMPTY} from "../../config/constants"

export const getSeoContent = async (
    siteUrl: string,
    headers: IncomingHttpHeaders,
    tpLitePath = "",
): Promise<string> => {
    try {
        const {cookie, ...rest} = headers
        const getAppDataApi = AppApiConfig("getSeoDataOnClient")
        // This is a HOT FIX to get the cors issue sorted for Home subsite. PBI 3739451 to address to root cause.
        delete rest["x-next-tabbed-navigation"]
        delete rest["x-next-realm-entrypoint"]
        delete rest["x-next-onsite-consent"]

        const tpLitePathSet = tpLitePath !== "" && tpLitePath !== TPLITE_CLIENT_EMPTY

        // Needs to include the tpSubsite path here to request if required from the tpClient endpoints
        const response = await axios({
            method: getAppDataApi.method,
            url: `${siteUrl}${tpLitePathSet ? `/${tpLitePath}` : ""}${getAppDataApi.localEndpoint()}`,
            headers: rest as {
                [header: string]: string
            },
        })

        let html = ""

        const isValidLink = link => {
            const {target, title} = link
            return (
                title !== null &&
                title !== undefined &&
                target !== null &&
                target !== undefined &&
                target !== SEO_IGNORE_LINK &&
                !SEO_IGNORE_LINK_REGEX.test(target)
            )
        }

        response.data.items.forEach(dept => {
            html += `<section><h4 data-category-name=${dept.title}>${dept.title}</h4>`
            dept.items.forEach(link => {
                if (isValidLink(link)) {
                    html += `<a href=${configRelativePathURL(
                        `${tpLitePathSet ? `/${tpLitePath}` : ""}${link.target}`,
                        siteUrl,
                    )} tabIndex=-1>${link.title}</a>`
                }
            })
            html += "</section>"
        })

        return html
    } catch (ex) {
        logger.error(ex)
        throw ex
    }
}
